import React from "react";

const PayCodes = () => {
    return <div>Pay Codes</div>;
};

export default PayCodes;